import React, { Children, useEffect, useState, useRef } from 'react'

import arrowIcon from "../../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Site/__Page - Forward.svg";
import Modal from '../../../../Modal/Modal';
import List from './List';
import AffectedSwitchesList from './AffectedSwitchesList';
import Button1 from '../../../Button/Button1';
import { addActionToAdvRule, deleteAdvRule, getSiteByUUID, removeActionFromAdvRule, setAdvRuleEnabled, setInputRuleApi } from '../../../../../Api Methods/Api';
import { useDispatch, useSelector } from 'react-redux';
import Button2 from '../../../Button/Button2';
import areYouSureAnim from '../../../../../assets/animations/areYouSure.json'
import successAnim from '../../../../../assets/animations/success.json'
import failAnim from '../../../../../assets/animations/fail.json'
import { act } from 'react';
import { Description } from '@headlessui/react';
import { format } from 'date-fns';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog';
import Lottie from 'lottie-react';
import ChoosePin from '../CreateRuleNew/ChoosePin';
import { Divider } from 'primereact/divider';
import ChooseWhatAdvRule from '../CreateRuleNew/ChooseWhatAdvRule';
import AddAdvRuleAction from '../CreateRuleNew/AddAdvRuleAction';
import ChooseWhatAddAdvRuleAction from '../CreateRuleNew/ChooseWhatAddAdvRuleAction';
import { RuleProvider, useRule } from '../CreateRuleNew/RuleReducer';
import { Link } from 'react-router-dom';
import RuleCard from '../../Rules/RuleCard';
import UseDisplayUserName from '../../../../hooks/UseDisplayUserName';


const AdvRuleLayout = ({ item, fetchAutomations, pins, smartLocks }) => {
    console.log(item);

    const { rule, conditions, actions, trigger } = item;
    const { state, dispatch } = useRule(RuleProvider);
    const client = useSelector(state => state.auth.client);
    const token = useSelector(state => state.auth.token);
    const DeviceUUID = useSelector(state => state.auth.DeviceUUID);
    const role = useSelector(state => state.auth.role);
    const [allSites, setAllSites] = useState({});
    const [_actions, setActions] = useState(actions);
    const [_rule, setRule] = useState(rule);
    const [masterSite, setMasterSite] = useState("")


    const ruleName = _rule.name || "No name provided"
    const ruleOwner = rule.site_owner
    const ruleDescription = _rule.description || "No description provided"
    const ruleEnabled = _rule.is_enabled == 1
    const created = _rule.created_at
    const createdBy = UseDisplayUserName(_rule.created_by_name)
    const lastUpdated = _rule.updated_at
    const ruleID = _rule.rule_id

    // Time-triggered rules fire on a schedule (trigger.type === "TIME") rather than off a pin
    // changing status — the pin condition just describes the status it must still be in at that
    // time. `trigger` normally arrives as its own sibling object (mirroring the shape sent on
    // create), but fall back to flattened fields on the rule row in case the API returns it that way.
    const isTimeTriggerRule = (trigger?.type ?? _rule.trigger_type) === "TIME";
    const triggerLocalTime = trigger?.local_time ?? _rule.local_time ?? null;
    const triggerTimezone = trigger?.timezone ?? _rule.timezone ?? null;
    const triggerDaysOfWeekRaw = trigger?.days_of_week ?? _rule.days_of_week ?? null;
    const triggerDaysOfWeek = Array.isArray(triggerDaysOfWeekRaw)
        ? triggerDaysOfWeekRaw.map(String)
        : (typeof triggerDaysOfWeekRaw === "string" ? JSON.parse(triggerDaysOfWeekRaw).map(String) : null);

    const [showEditRule, setShowEditRule] = useState(false)
    const [showConfirmation, setShowConfirmation] = useState(false)
    const [showSuccess, setShowSuccess] = useState(false)
    const [showFail, setShowFail] = useState(false)
    const [showEdit, setShowEdit] = useState(false)
    const [showAddAction, setShowAddAction] = useState(false)
    const [showChooseWhat, setShowChooseWhat] = useState(false)

    let usedKeys = []
    let usedAffectedKeys = []

    const [newSelectedPin, setNewSelectedPin] = useState({})

    const [linkedSites, setLinkedSites] = useState([])

    const apiData = {
        token,
        client
    }

    const ModalDialog = useRef();
    const ClearStatesChildComponetRef = useRef();

    useEffect(() => {
        if (!rule) return;
        getSiteInfo(_rule.site_owner);
        // _actions.map(action => {
        //     setLinkedSites(getSiteInfo(action.site_to))
        // })
        


        const uniqueActionSites = [
            ...new Set(_actions.map(a => a.site_to).filter(id => id !== _rule.site_owner))
        ];

        uniqueActionSites.forEach(uuid => getSiteInfo(uuid));
    }, [_rule, _actions]);

    const HandleShowModal = () => {
        ModalDialog.current.open();
    }

    const HandleCloseModal = () => {
        ModalDialog.current.close();
        if (ClearStatesChildComponetRef.current && ClearStatesChildComponetRef.current.HandleResetAllStates) {
            ClearStatesChildComponetRef.current.HandleResetAllStates();
        }
        HandelResetModal();
    }

    const [modalTitle, setModalTitle] = useState("")
    const [modalComponent, setModalComponent] = useState()
    const [modalPageIndex, setModalPageIndex] = useState(null);

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                HandelResetModal();
                setModalPageIndex(null);
            }
        };

        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    const HandelResetModal = () => {
        setModalPageIndex(null);
    }

    // re-render modal to show new modal componet. 
    useEffect(() => {
        console.log(modalPageIndex);
        switch (modalPageIndex) {
            case 1:
                //setModalComponent(<ScheduledAction body={body} OutPutOptions={OutPutOptions} title={title} isReminder={isReminder} nextPage={setModalPageIndex} onSubmit={UpdateSchedule} DeleteSchedule={DeleteSchedule} showRemoveScheduleButton={showRemoveScheduleButton} />)
                HandleShowModal();
                break;
            case 3:
                //setModalComponent(<SelectOutputs body={body} setBody={setBody} listItems={OutPutOptions} modalPageIndex={modalPageIndex} nextPage={setModalPageIndex} showAutomation={isReminder} time={time} />)
                break;
        }

    }, [modalPageIndex, item])


    const apiDispatch = useDispatch();


    const deleteRule = async () => {
        const response = await deleteAdvRule(apiData, ruleID, apiDispatch)
        if (response.success) {
            setShowEditRule(false)
            setShowConfirmation(false)
            setShowSuccess(true)
            HandleCloseModal()
            fetchAutomations()
        } else {
            setShowConfirmation(false)
            setShowFail(true)
        }
    }

    const convertUTCTimeToLocal = (utcTimeStr) => {
        if (!utcTimeStr) return null;
        const [hours, minutes] = utcTimeStr.split(':');
        const d = new Date();
        d.setUTCHours(parseInt(hours, 10), parseInt(minutes, 10), 0, 0);
        return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
    };

    const convertDaysOfTheWeek = (daysSelected) => {
        // Server uses JS convention: 0=Sun, 1=Mon, 2=Tues, 3=Wed, 4=Thur, 5=Fri, 6=Sat
        const dayMap = { "0": "Sun", "1": "Mon", "2": "Tues", "3": "Wed", "4": "Thur", "5": "Fri", "6": "Sat" };
        const selectedDayNames = daysSelected
            .slice()
            .sort((a, b) => a - b)
            .map(d => dayMap[d])
            .join(',');

        if (selectedDayNames === "Mon,Tues,Wed,Thur,Fri") {
            return "on weekdays";
        } else if (selectedDayNames === "Sun,Sat") {
            return "on weekends";
        } else if (selectedDayNames === "Sun,Mon,Tues,Wed,Thur,Fri,Sat") {
            return "everyday";
        } else {
            return "on " + selectedDayNames.split(',').join(', ');
        }
    }

    const getSiteInfo = async (uuid) => {
        if (!uuid) return;

        const response = await getSiteByUUID(apiData, uuid, apiDispatch);
        if (response.success) {
            const deviceDetailsParsed = JSON.parse(response.data.deviceDetails);

            setAllSites(prev => ({
                ...prev,
                [uuid]: {
                    ...response.data,
                    deviceDetailsParsed
                }
            }));
        }
    };

    const formatMsDuration = (ms) => {
        if (ms % 3600000 === 0) return `${ms / 3600000} hour${ms === 3600000 ? "" : "s"}`;
        if (ms % 60000 === 0) return `${ms / 60000} minute${ms === 60000 ? "" : "s"}`;
        return `${ms / 1000} second${ms === 1000 ? "" : "s"}`;
    };

    // Gateway-event trigger conditions (see WizardStepTrigger/WizardStepConditions) describe a
    // padlock event straight off the gateway rather than a device pin, so they carry no `pin` /
    // `pin_state` for convertConditionPinState to read - describe them from gateway_event_subtype instead.
    const GATEWAY_EVENT_PHRASES = {
        unlocked: "a correct pin entry",
        opened: "a padlock open",
        locked: "a padlock close",
        invalidPIN: "an invalid pin attempt",
    };

    const describeGatewayCondition = (condition) => {
        const phrase = GATEWAY_EVENT_PHRASES[condition.gateway_event_subtype] || condition.pin_name || "a gateway event";
        return `${phrase} is reported by the gateway`;
    };

    const convertConditionPinState = (deviceDetails, condition, timeframeMs, isTimeTrigger = false) => {
        const pinNumber = condition.pin;
        if (!deviceDetails || !deviceDetails[pinNumber]) return "Loading...";

        const pin = deviceDetails[pinNumber];
        const isLock = smartLocks.some(lock => lock.outputPin == pinNumber);
        const isAbsence = condition.is_absence_condition;
        const isDeadline = condition.is_deadline_condition;
        const onLabel = isLock ? "closed" : (condition.pin_status_on || pin.pinStatusOn);
        const offLabel = isLock ? "open" : (condition.pin_status_off || pin.pinStatusOff);
        const absenceSuffix = isAbsence && timeframeMs > 0 ? ` within ${formatMsDuration(timeframeMs)}` : "";

        switch (condition.pin_state) {
            case "ARMED":
                return isAbsence ? `has NOT been ${onLabel}${absenceSuffix}` : isDeadline ? `is already ${onLabel}` : isTimeTrigger ? `is still ${onLabel}` : `changes status to ${onLabel}`;
            case "DISARMED":
                return isAbsence ? `has NOT been ${offLabel}${absenceSuffix}` : isDeadline ? `is already ${offLabel}` : isTimeTrigger ? `is still ${offLabel}` : `changes status to ${offLabel}`;
            case "TEMP_ARM":
                return `is temporarily ${onLabel}`
            case "TEMP_DISARM":
                return `is temporarily ${offLabel}`
            case "PULSE":
                return `pulses`
            case "ANY":
                return isDeadline ? `is ${onLabel} or ${offLabel}` : isTimeTrigger ? `is ${onLabel} or ${offLabel} (toggled)` : `changes status to ${onLabel} or ${offLabel} (toggled)`;
            default:
                return "Unknown";
        }
    };

    // Trigger conditions/status checks are each governed by their own logic operator, plus (for
    // multiple trigger conditions) an optional timeframe window between them / before status checks
    // are evaluated — see WizardStepConditions/WizardStepDeadlineChecks for where these are set.
    const withConnectors = (items, operatorLabel) => {
        const result = [];
        items.forEach((item, i) => {
            result.push(item);
            if (i < items.length - 1) result.push({ text: operatorLabel, variant: "connector" });
        });
        return result;
    };

    const formatAlertRecipient = (action) => {
        switch (action.alert_recipient_type) {
            case "JUST_ME": return "rule creator";
            case "ALL_MANAGERS": return "all managers";
            case "ALL_STANDARD_USERS": return "all standard users";
            case "SELECTED_USERS": return `${action.target_users?.length ?? 0} specific user(s)`;
            default: return action.alert_recipient_type ?? "unknown";
        }
    };

    const formatAlertType = (action) => {
        switch (action.alert_level){
            case "STANDARD": return "standard";
            case "CRITICAL": return "CRITIAL";
            default: return ""
        }
    }

    const SNAPSHOT_PROVIDER_LABELS = { AJAX: "Ajax", DAHUA: "Dahua", HIKVISION: "Hikvision" };

    const formatSnapshotAction = (action) => {
        const targets = action.snapshot_targets ?? [];
        if (targets.length === 0) return "Take snapshot";
        const targetText = targets
            .map(t => {
                const providerLabel = SNAPSHOT_PROVIDER_LABELS[t.provider] ?? t.provider;
                return t.channel != null ? `${providerLabel} - Channel ${t.channel}` : providerLabel;
            })
            .join(", ");
        return `Take snapshot (${targetText})`;
    }


    const convertActionPinState = (deviceDetails, pinNumber, pinState) => {
        if (!deviceDetails || !deviceDetails[pinNumber]) return "Loading...";

        switch (pinState){
            case "MATCH" :
                return `match its state`
            case "ARM":
                return `${deviceDetails[pinNumber].actionOneOffLabel || "arm"}`
            case "DISARM": 
                return `${deviceDetails[pinNumber].actionOneOnLabel || "disarm"}`
            case "PULSE":
                return `pulse`
            case "TEMP_ARM":
                return `temporarily ${deviceDetails[pinNumber].actionOneOffLabel || "arm"}`
            case "TEMP_DISARM":
                return `temporarily ${deviceDetails[pinNumber].actionOneOnLabel || "disarm"}`
            case "TOGGLE":
                return "toggle"
            default: 
                return "Unknown"
        }
    }

    const setRuleEnabled = async () => {
        const body = {
            enabled: _rule.is_enabled == 1 ? false : true
        }

        const response = await setAdvRuleEnabled(apiData, body, _rule.rule_id, apiDispatch)
        if (response.success){
            const updatedRule = {
                ..._rule,
                is_enabled: _rule.is_enabled == 1 ? 0 : 1
            };
            setRule(updatedRule)
        }
    }

    const deleteAction = async (actionID) => {
        const response = await removeActionFromAdvRule(apiData, actionID, apiDispatch)
        if (response.success){
            setActions(prev =>
                    prev.filter(a => a.action_id !== actionID)
            );
        }
    }

    const navigate = () => {
        setShowAddAction(false)
        setShowChooseWhat(true)
    }

    const saveNewAction = async () => {
        setShowChooseWhat(false)
        const response = await addActionToAdvRule(apiData, _rule.rule_id, state.actionToAdd, apiDispatch)
        console.log(_rule.rule_id);
        console.log(state.actionToAdd);
        console.log(response);
        if (response.success){
             const updatedActions = [..._actions, state.actionToAdd];
             setActions(updatedActions)
        }
    }

    // const navigateToSite = (uuid) => {
    //     dispatch(serviceActions.setDeviceUUID(uuid));
    //     useSetCookie("DeviceUUID", uuid, 1);
    //     navigate("/portal/SiteView/" + uuid);
    // }

    const triggerConditions = conditions.filter(c => !c.is_deadline_condition);
    const checkConditions = conditions.filter(c => c.is_deadline_condition);
    const isSequential = _rule.evaluation_mode === "SEQUENCE";
    const conditionsLogicOperator = _rule.conditions_logic_operator || "AND";
    const deadlineLogicOperator = _rule.deadline_logic_operator || "AND";
    const timeframeMs = _rule.timeframe_window_ms ?? (isSequential ? _rule.sequence_timeout_ms : null);
    const timeframeMode = _rule.timeframe_window_mode;

    // The backend requires the day/time restriction to be duplicated onto every non-deadline
    // condition, but it's really one rule-wide restriction - so read it once (from the first
    // trigger condition, since they're all identical) rather than per condition.
    const restrictionCondition = !isTimeTriggerRule ? triggerConditions[0] : null;
    const restrictionDaysArr = restrictionCondition?.days_of_week ? JSON.parse(restrictionCondition.days_of_week) : ["0", "1", "2", "3", "4", "5", "6"];
    const restrictionDaysRestricted = restrictionDaysArr.length < 7;
    const restrictionTimeText = restrictionCondition?.time_window_start && restrictionCondition?.time_window_end
        ? `between ${convertUTCTimeToLocal(restrictionCondition.time_window_start)} and ${convertUTCTimeToLocal(restrictionCondition.time_window_end)}`
        : '';
    const restrictionDaysText = restrictionDaysRestricted ? convertDaysOfTheWeek(restrictionDaysArr) : '';
    const restrictionPhrase = [restrictionTimeText, restrictionDaysText].filter(Boolean).join(' ');
    const hasRestriction = !!restrictionPhrase;
    const restrictionItems = hasRestriction ? [restrictionPhrase.charAt(0).toUpperCase() + restrictionPhrase.slice(1)] : [];

    const rawTriggerItems = triggerConditions.map(condition => {
        const site = allSites[_rule.site_owner];
        if (!site) return null;
        const deviceDetails = site?.deviceDetailsParsed;
        const conditionText = condition.condition_type === "GATEWAY_EVENT"
            ? describeGatewayCondition(condition)
            : `${deviceDetails?.[condition.pin]?.pinName || 'Loading...'} ${convertConditionPinState(deviceDetails, condition, timeframeMs, isTimeTriggerRule)}`;
        const siteLabel = site.uuid != DeviceUUID ? `${site.tag || site.key} - ` : '';
        const text = `${siteLabel}${isTimeTriggerRule ? "If" : "When"} ${conditionText}`.trim();
        if (site.uuid != DeviceUUID) {
            return (
                <a href={`/Dashboard/SiteView/${site.uuid}`} target="_blank" rel="noopener noreferrer">
                    {text}
                </a>
            );
        }
        return text;
    }).filter(Boolean);

    const triggerScheduleNote = isTimeTriggerRule ? {
        text: `At ${triggerLocalTime ? triggerLocalTime.slice(0, 5) : "..."}${triggerTimezone ? ` (${triggerTimezone})` : ""}${triggerDaysOfWeek ? `, ${convertDaysOfTheWeek(triggerDaysOfWeek)}` : ""}`,
        variant: "note",
    } : null;

    const triggerItems = [
        ...(triggerScheduleNote ? [triggerScheduleNote] : []),
        ...withConnectors(rawTriggerItems, isSequential ? "THEN" : conditionsLogicOperator),
        ...(timeframeMs > 0 && triggerConditions.length > 1 ? [{
            text: `Must all happen within ${formatMsDuration(timeframeMs)} of each other (${timeframeMode === "SLIDING" ? "sliding" : "fixed"} window)`,
            variant: "note",
        }] : []),
    ];

    const rawStatusCheckItems = checkConditions.map(condition => {
        const site = allSites[_rule.site_owner];
        if (!site) return null;
        const deviceDetails = site?.deviceDetailsParsed;
        const pinName = deviceDetails?.[condition.pin]?.pinName || 'Loading...';
        const stateText = convertConditionPinState(deviceDetails, condition, timeframeMs);
        const siteLabel = site.uuid != DeviceUUID ? `${site.tag || site.key} - ` : '';
        const text = `${siteLabel}${pinName} ${stateText}`.trim();
        if (site.uuid != DeviceUUID) {
            return (
                <a href={`/Dashboard/SiteView/${site.uuid}`} target="_blank" rel="noopener noreferrer">
                    {text}
                </a>
            );
        }
        return text;
    }).filter(Boolean);

    const statusCheckItems = rawStatusCheckItems.length > 0 ? [
        ...(timeframeMs > 0 ? [{
            text: `Checked ${formatMsDuration(timeframeMs)} after the trigger fires`,
            variant: "note",
        }] : []),
        ...withConnectors(rawStatusCheckItems, deadlineLogicOperator),
    ] : [];

    const actionItems = _actions.map(action => {
        console.log(action);
        if (action.action_type === "SEND_ALERT") return `Will send ${formatAlertType(action)} alert to ${formatAlertRecipient(action)}`;
        if (action.action_type === "SEND_ARC") return "Will notify monitoring arc"
        if (action.action_type === "CREATE_SNAPSHOT") return formatSnapshotAction(action);
        const site = allSites[action.site_to];
        if (!site) return null;
        const tag = site.tag || "";
        const deviceDetails = site?.deviceDetailsParsed;
        const pinName = deviceDetails?.[action.target_output]?.pinName || 'Loading...';
        const actionText = convertActionPinState(deviceDetails, action.target_output, action.control_type);
        const timeText = action.temporary_time_ms && (action.control_type === "TEMP_ARM" || action.control_type === "TEMP_DISARM")
            ? ` for ${action.temporary_time_ms / 60000 < 1 ? `${action.temporary_time_ms / 1000} seconds` : `${action.temporary_time_ms / 60000} minutes`}`
            : '';
        const delayText = action.delay_seconds > 0 ? ` after ${action.delay_seconds} seconds` : '';
        const text = `${tag} (${site.key}) - ${pinName} will ${actionText}${timeText}${delayText}`.trim();
        if (site.uuid != DeviceUUID) {
            return (
                <a href={`/Dashboard/SiteView/${site.uuid}`} target="_blank" rel="noopener noreferrer">
                    {text}
                </a>
            );
        }
        return text;
    }).filter(Boolean);

    return (
        <>
            <Modal ref={ModalDialog} title={modalTitle} HandleShowModal={HandleShowModal} HandleCloseModal={HandleCloseModal} style={{ minWidth: "700px", minHeight: "420.5px" }} modalLayoutStyle={{ alignItems: "center" }}>
                {modalComponent}
            </Modal>

            {allSites[_rule.site_owner] && (
                <Dialog
                    header="View rule"
                    visible={showEdit}
                    style={{ width: "40vw", maxHeight: "70vh", overflowY: "auto" }}
                    onHide={() => setShowEdit(false)}
                >

                    <p>
                        {`Rule owner: ${allSites[_rule.site_owner].tag || ""} (${allSites[_rule.site_owner].key})`}
                    </p>
                    <p>
                        {`Name: ${_rule.name}`}
                    </p>
                    <p>
                        {`Description: ${_rule.description ?? "Not provided"}`}
                    </p>
                    <p style={{ display: "flex", alignItems: "center", gap: "2px" }}>
                        {_rule.is_enabled == 1 ? "Rule status: enabled" : "Rule status: disabled"}
                        <Button icon="pi pi-arrow-right-arrow-left" rounded text aria-label="Filter" onClick={() => setRuleEnabled()}/>
                    </p>
                    <p>{`Created: ${format(new Date(_rule.created_at), "MMM do, yyyy - HH:mm")}`}</p>
                    <Divider type='solid' />
                   <h3 style={{color:"#6e6e6eff", fontWeight:600}}>Trigger:</h3>
                    {isTimeTriggerRule && (
                        <p style={{ margin: "0 0 6px 0", fontSize: "13px", color: "#3d3d3d" }}>
                            {`At ${triggerLocalTime ? triggerLocalTime.slice(0, 5) : "..."}${triggerTimezone ? ` (${triggerTimezone})` : ""}${triggerDaysOfWeek ? `, ${convertDaysOfTheWeek(triggerDaysOfWeek)}` : ""}`}
                        </p>
                    )}
                    {triggerConditions.map((condition, i) => {
                        const site = allSites[_rule.site_owner]; // master site

                        if (!site) return null;
                        const deviceDetails = site?.deviceDetailsParsed;
                        const conditionText = condition.condition_type === "GATEWAY_EVENT"
                            ? describeGatewayCondition(condition)
                            : `${deviceDetails?.[condition.pin]?.pinName || 'Loading...'} ${convertConditionPinState(deviceDetails, condition, timeframeMs, isTimeTriggerRule)}`;
                        return (
                            <div key={condition.condition_id}>
                                <p style={{ display: "flex", alignItems: "center", gap: "2px" }}>
                                {`${isTimeTriggerRule ? "If" : "When"} ${conditionText}`}

                                {/* <Button icon="pi pi-pen-to-square" rounded text aria-label="Filter" /> */}
                                </p>
                                {i < triggerConditions.length - 1 && (
                                    <p style={{ margin: "0 0 4px 0", fontSize: "11px", fontWeight: 700, color: "#b0b0b0", textTransform: "uppercase" }}>
                                        {isSequential ? "THEN" : conditionsLogicOperator}
                                    </p>
                                )}
                            </div>
                        );
                    })}
                    {timeframeMs > 0 && triggerConditions.length > 1 && (
                        <p style={{ margin: "2px 0 0 0", fontSize: "12px", color: "#9e9e9e", fontStyle: "italic" }}>
                            {`Must all happen within ${formatMsDuration(timeframeMs)} of each other (${timeframeMode === "SLIDING" ? "sliding" : "fixed"} window)`}
                        </p>
                    )}

                    {hasRestriction && (
                        <>
                            <Divider type='solid' />
                            <h3 style={{color:"#6e6e6eff", fontWeight:600}}>Restrictions:</h3>
                            <p style={{ margin: 0, fontSize: "13px", color: "#3d3d3d" }}>
                                {restrictionItems[0]}
                            </p>
                        </>
                    )}

                    {checkConditions.length > 0 && (
                        <>
                            <Divider type='solid' />
                            <h3 style={{color:"#6e6e6eff", fontWeight:600}}>{`Status checks (${deadlineLogicOperator}):`}</h3>
                            {timeframeMs > 0 && (
                                <p style={{ margin: "0 0 6px 0", fontSize: "12px", color: "#9e9e9e", fontStyle: "italic" }}>
                                    {`Checked ${formatMsDuration(timeframeMs)} after the trigger fires`}
                                </p>
                            )}
                            {checkConditions.map((condition, i) => {
                                const site = allSites[_rule.site_owner];
                                if (!site) return null;
                                const deviceDetails = site?.deviceDetailsParsed;
                                return (
                                    <div key={condition.condition_id}>
                                        <p style={{ display: "flex", alignItems: "center", gap: "2px" }}>
                                            {`${deviceDetails?.[condition.pin]?.pinName || 'Loading...'} ${convertConditionPinState(deviceDetails, condition, timeframeMs)}`}
                                        </p>
                                        {i < checkConditions.length - 1 && (
                                            <p style={{ margin: "0 0 4px 0", fontSize: "11px", fontWeight: 700, color: "#b0b0b0", textTransform: "uppercase" }}>
                                                {deadlineLogicOperator}
                                            </p>
                                        )}
                                    </div>
                                );
                            })}
                        </>
                    )}
                    <Divider type='solid' />
                    <h3 style={{color:"#6e6e6eff", fontWeight:600}}>Actions:</h3>
                    {_actions.map(action => {

                        if (action.action_type === "SEND_ALERT") {
                            return (
                                <div key={action.action_id}>
                                    <p style={{ display: "flex", alignItems: "center", gap: "2px" }}>
                                        {`Will send ${formatAlertType(action)} alert to ${formatAlertRecipient(action)}`}
                                        <Button icon="pi pi-trash" rounded text aria-label="Delete" onClick={() => deleteAction(action.action_id)} />
                                    </p>
                                    <Divider type='dashed' />
                                </div>
                            );
                        }

                        if (action.action_type === "SEND_ARC") {
                            return (
                                <div key={action.action_id}>
                                    <p style={{ display: "flex", alignItems: "center", gap: "2px" }}>
                                        {`Will notify monitoring arc`}
                                        <Button icon="pi pi-trash" rounded text aria-label="Delete" onClick={() => deleteAction(action.action_id)} />
                                    </p>
                                    <Divider type='dashed' />
                                </div>
                            );
                        }

                        if (action.action_type === "CREATE_SNAPSHOT") {
                            return (
                                <div key={action.action_id}>
                                    <p style={{ display: "flex", alignItems: "center", gap: "2px" }}>
                                        {formatSnapshotAction(action)}
                                        <Button icon="pi pi-trash" rounded text aria-label="Delete" onClick={() => deleteAction(action.action_id)} />
                                    </p>
                                    <Divider type='dashed' />
                                </div>
                            );
                        }

                        const site = allSites[action.site_to];
                        if (!site) return null;
                        const tag = site.tag || "";
                        const deviceDetails = site?.deviceDetailsParsed;
                        return (
                            <div key={action.action_id}>
                                <p style={{ display: "flex", alignItems: "center", gap: "2px" }}>
                                    {`${tag} (${site.key}) -
                                    ${deviceDetails?.[action.target_output]?.pinName || 'Loading...'}
                                    will ${convertActionPinState(deviceDetails, action.target_output, action.control_type)}
                                    ${(action.temporary_time_ms && (action.control_type == "TEMP_ARM" || action.control_type == "TEMP_DISARM"))? (action.temporary_time_ms / 60000 < 1 ? `For ${action.temporary_time_ms / 1000} seconds` : `For ${action.temporary_time_ms / 60000} minutes`) : ''}
                                    ${action.delay_seconds > 0 ? `After ${action.delay_seconds} seconds` : ''}`}
                                    <Button icon="pi pi-trash" rounded text aria-label="Delete" onClick={() => deleteAction(action.action_id)} />
                                </p>
                                <Divider type='dashed' />
                            </div>
                        );
                    })}
                    
                    <Button label="Add an action" severity="info" rounded icon="pi pi-plus" onClick={() => {setShowAddAction(true)}} />

                </Dialog>)}

            <Dialog
                header="Add rule action"
                visible={showAddAction}
                style={{ width: "40vw" }}
                onHide={() => setShowAddAction(false)}
            >
                <AddAdvRuleAction rule={_rule} actions={_actions} conditions={conditions} pins={pins} smartLocks={smartLocks} closeDialog={() => navigate()} setNewSelectedPin={setNewSelectedPin}/>
            </Dialog>

            <Dialog 
                header="Add action"
                visible={showChooseWhat}
                style={{ width: "40vw" }}
                onHide={() => setShowChooseWhat(false)}
            >
                <ChooseWhatAddAdvRuleAction selectedPinToAffect={newSelectedPin[0]} closeDialog={() => saveNewAction()} />
            </Dialog>

            <Dialog
                header="Success"
                visible={showSuccess}
                style={{ width: "40vw" }}
                onHide={() => setShowSuccess(false)}
            >
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                    <h3 style={{ color: "#6e6e6eff" }}>Action completed successfully</h3>
                    <Lottie
                        animationData={successAnim}
                        loop={false}
                        style={{ width: 250, height: 250, margin: "0px" }}
                    />

                    <Button label="Close & refresh" icon="pi pi-times" severity="primary" onClick={() => { setShowSuccess(false); fetchAutomations(); }} />
                </div>
            </Dialog>

            <Dialog
                header="Error"
                visible={showFail}
                style={{ width: "40vw" }}
                onHide={() => setShowFail(false)}
            >
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                    <Lottie
                        animationData={failAnim}
                        loop={false}
                        style={{ width: 150, height: 150, margin: "0px" }}
                    />
                    <br />
                    <h3 style={{ color: "#6e6e6eff" }}>Something went wrong!</h3>
                    <p style={{ textAlign: "center" }}>Failed to complete requested action, please try again.</p>
                    <br></br>

                    <Button icon="pi pi-times"  label="Okay" severity="secondary" onClick={() => setShowFail(false)} />
                </div>
            </Dialog>

            <Dialog
                header="Are you sure?"
                visible={showConfirmation}
                style={{ width: "40vw" }}
                onHide={() => setShowConfirmation(false)}
            >
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>

                    <Lottie
                        animationData={areYouSureAnim}
                        loop={false}
                        style={{ width: 150, height: 150, margin: "0px" }}
                    />
                    <br />
                    <h3 style={{ color: "#6e6e6eff" }}>{`Are you sure you want to delete this rule?`}</h3>
                    <br />
                    <Button label="No, cancel"  icon="pi pi-times" severity="secondary" onClick={() => setShowConfirmation(false)} />
                    <br />
                    <Button label="Yes, delete rule" icon="pi pi-check" severity="danger" onClick={() => deleteRule()} />

                </div>
            </Dialog>

            <Dialog
                header="Edit Rule"
                visible={showEditRule}
                style={{ width: "40vw" }}
                onHide={() => setShowEditRule(false)}
            >
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '10px', // Spacing between buttons
                    padding: '15px',
                    width: '100%', // Adjust width as needed
                    background: 'white',
                    borderRadius: '8px',
                    alignContent: "center",
                    alignItems: "center"
                }}>
                    <Button2 style={{
                        minWidth: "350px",
                        minHeight: "50px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",

                    }}
                        onClick={() => {setShowEdit(true); setShowEditRule(false)}}>View/edit rule</Button2>

                    {(role === "admin" || role === "TechSupport") && <Button2 style={{
                        minWidth: "350px",
                        minHeight: "50px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        color: "#ff5c5c"
                    }}
                        onClick={() => setShowConfirmation(true)}>Delete rule</Button2>}

                    <Button2 style={{
                        minWidth: "350px",
                        minHeight: "50px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    }}
                        onClick={() => setShowEditRule(false)}>Cancel</Button2>
                </div>


            </Dialog>
            
            <RuleCard
                header={`Rule`}
                subHeader={
                    `${ruleName}`
                }
                onClick={() => (role === "admin" || role === "TechSupport") && ruleOwner == DeviceUUID ? setShowEditRule(true) : null}
                trigger={triggerItems}
                restrictions={restrictionItems}
                statusChecks={statusCheckItems}
                actions={actionItems}
                meta={[]}
                active={ruleEnabled}
                footer={
                                    createdBy && created
                                      ? `Created by ${createdBy} on ${format(
                                          new Date(created),
                                          "MMM do, yyyy - HH:mm"
                                        )}`
                                      : null
                                  }     
            />
        </>
    )
}

export default AdvRuleLayout;




